import { UserIdentityProvider, Visitor } from 'graphql/generated/graphqlTypes';
import { Translation } from 'hooks/useTranslation/useTranslation';

export enum VisitorOrigin {
  EntraId = 'ENTRA_ID',
  Atlas = 'ATLAS',
  KeySharing = 'KEY_SHARING',
  Unknown = 'UNKNOWN'
}

export const getVisitorOrigin = (visitor: Pick<Visitor, 'identityProvider' | 'email'>): VisitorOrigin => {
  switch (visitor.identityProvider) {
    case UserIdentityProvider.Entra:
      return VisitorOrigin.EntraId;
    case UserIdentityProvider.Cognito:
      return VisitorOrigin.Atlas;
    case UserIdentityProvider.Internal:
      return visitor.email ? VisitorOrigin.Atlas : VisitorOrigin.KeySharing;
    default:
      return VisitorOrigin.Unknown;
  }
};

export const getVisitorOriginLabel = (
  visitor: Pick<Visitor, 'identityProvider' | 'email'>,
  translation: Translation
): string => {
  switch (getVisitorOrigin(visitor)) {
    case VisitorOrigin.EntraId:
      return translation.entra_id;
    case VisitorOrigin.Atlas:
      return translation.atlas;
    case VisitorOrigin.KeySharing:
      return translation.key_sharing;
    default:
      return translation.unknown;
  }
};
